import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.667",
        d: "M16.667 2.5v3.333m1.666-1.666H15m-11.667 10v1.666M4.167 15H2.5m5.78-2.083a1.67 1.67 0 0 0-1.197-1.198l-5.112-1.318a.417.417 0 0 1 0-.802L7.083 8.28a1.67 1.67 0 0 0 1.198-1.197l1.318-5.112a.417.417 0 0 1 .803 0l1.317 5.112a1.67 1.67 0 0 0 1.198 1.198l5.112 1.317a.417.417 0 0 1 0 .804l-5.112 1.317a1.67 1.67 0 0 0-1.198 1.198l-1.318 5.112a.417.417 0 0 1-.803 0z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }